import { QueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export function invalidateStatisticsAfterVisitMutation(
  response: AxiosResponse,
  queryClient: QueryClient,
): void {
  const method = response.config.method?.toLowerCase();
  const url = response.config.url || '';
  const changesVisit =
    /\/api\/visits?(\/|$)/.test(url) ||
    /\/api\/conversation\/(start|complete|cancel)([/?]|$)/.test(url);
  if (method && !['get', 'head', 'options'].includes(method) && changesVisit) {
    void queryClient.invalidateQueries(['organization-statistics']);
    void queryClient.invalidateQueries(['professional-statistics']);
  }
}
